import React from 'react'
import {Route, Switch} from 'react-router-dom'
import Redirect from './Redirect'

export default function Services() {
  return (
    <Switch>
      <Route path="/justo-track/:trackingDeliveryId" exact component={Redirect} />
    </Switch>
  )
}
